import React from "react";
import "./App.css";
import Visualizer from "./Components/Visualizer";

function App() {
    return (
        <div>
            <Visualizer />
        </div>
    );
}

export default App;
